<template>
  <v-dialog v-model="dialog" max-width="1000" persistent>
    <v-form lazy-validation v-model="valid" ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            checklist ? "List Of Settlement Checked" : "List Of Settlement Approved"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-row v-if="!loading">
            <v-col cols="12" class="mt-2">
              <v-data-table
                :headers="headers"
                :items="items"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.no="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.date="{ item }">
                  {{ formatDate(item.date) }}
                </template>
                <template v-slot:item.bankAccountNumber="{ item }">
                  {{ accountNumber(item) }}
                </template>
                <template v-slot:item.totalAmount="{ item }">
                  {{ formatPrice(item.totalAmount) }}
                </template>
                <template v-slot:item.totalUseAmount="{ item }">
                  {{ formatPrice(item.totalUseAmount) }}
                </template>
                <template v-slot:item.totalRemainAmount="{ item }">
                  {{ formatPrice(item.totalRemainAmount) }}
                </template>
                <template v-slot:item.pphAmount="{ item }">
                  {{ formatPrice(item.pphAmount) }}
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" v-if="!checklist">
              <v-checkbox
                v-model="bulk"
                label="Transfer menjadi 1x tranfer untuk banyak settlement"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="!checklist && bulk">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="4">Total Amount Transfer :</v-col>
                <v-col cols="12" sm="12" md="6" lg="4"
                  ><strong>{{ formatPrice(totalAmountTransfer) }}</strong></v-col
                >
              </v-row>
            </v-col>
            <v-col cols="12" v-if="!checklist && !hasPinCookies">
              <v-text-field
                outlined
                dense
                flat
                background-color="white"
                v-model="pin"
                label="Pin"
                persistent-hint
                hint="Masukan PIN yang diperoleh dari APP"
                :rules="[v => !!v || 'Pin is required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="fill-height" align-content="center" justify="center" v-if="loading">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Processing transfer bank, please wait...
            </v-col>
            <v-col cols="6">
              <v-progress-linear indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close" class="mr-2" :disabled="loading">
            Close
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="loading">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from "moment";
import cookies from "@/services/cookies";
export default {
  name: "dialog-confirmation",
  props: {
    dialog: Boolean,
    items: Array,
    checklist: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
  },
  data() {
    return {
      bulk: false,
      valid: true,
      pin: "",
      hasPinCookies: false,
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Date",
          value: "date",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 4,
          text: "Kasbon Number",
          value: "kasbonNumber",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Kasbon Name",
          value: "name",
          sortable: false,
          align: "start",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "Bank Account Number",
          value: "bankAccountNumber",
          sortable: false,
          align: "start",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 6,
          text: "Total",
          value: "totalAmount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 7,
          text: "Total Use",
          value: "totalUseAmount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 8,
          text: "Total Remain",
          value: "totalRemainAmount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 8,
          text: "Total PPH",
          value: "pphAmount",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 8,
          text: "Created Date",
          value: "createdAt",
          sortable: true,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  computed: {
    totalAmountTransfer() {
      const total = this.items.reduce((acc, item) => {
        return acc + item.totalRemainAmount;
      }, 0);
      const pph = this.items.reduce((acc, item) => {
        return acc + item.pphAmount;
      }, 0);
      return Math.abs(total) - pph;
    },
  },
  methods: {
    checkPinCookies() {
      this.hasPinCookies = cookies.checkCookies();
      if (this.hasPinCookies) {
        this.pin = cookies.getCookies();
      }
    },
    save() {
      if (this.checklist) {
        this.$emit("save", this.items);
        return;
      }

      if (this.hasPinCookies) {
        this.$emit("save", { body: this.items, bulk: this.bulk, pin: this.pin });
      } else {
        if (this.$refs.form) {
          const isFormValid = this.$refs.form.validate();

          if (isFormValid) {
            cookies.generateCookies(this.pin);
            this.$emit("save", { body: this.items, bulk: this.bulk, pin: this.pin });
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Form validation failed. Please input pin",
            });
          }
        } else {
          this.$store.dispatch("toast", {
            type: "error",
            message:
              "Error: Could not find this.$refs.form. The form element might not be rendered in the DOM.",
          });
        }
      }
    },
    close() {
      this.$emit("close");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-yyyy");
    },
    accountNumber(item) {
      if (item.external) {
        return item.externalAccountNumber.accountNumber;
      } else {
        return item.bankAccountNumber;
      }
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.checkPinCookies();
      }
    },
  },
};
</script>

<style></style>
